import React, { Component } from 'react';
import { BASE_URL } from '../../constant';
import { IMG_URL, ADMIN_URL } from "../../constant";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import adsqr1 from '../../../src/assets/images/ad-banner/curatedsideadbanner_v1_1.png';
import adsqr2 from '../../../src/assets/images/ad-banner/curatedsideadbanner_v1_2.png';
import adsqr3gif from '../../../src/assets/images/ad-banner/adgiftest.gif';

const banner_arr = [
    {
        image: '/assets/images/ad-banner/300-250-180822-1.png',
        link: `https://www.bewise.in/bengaluru/after-school-activity/mind-and-skill-enrichment/coding/diya-edulabs`
    },
    {
        image: '/assets/images/ad-banner/300-250-180822-2.png',
        link: `https://www.bewise.in`
    },
    {
        image: '/assets/images/ad-banner/300-250-180822-3.png',
        link: `javascript:;`
    },
    {
        image: '/assets/images/ad-banner/300-250-180822-4.png',
        link: `javascript:;`
    },
    {
        image: '/assets/images/ad-banner/300-250-180822-5.png',
        link: `javascript:;`
    },
    {
        image: '/assets/images/ad-banner/300-250-180822-6.png',
        link: `https://www.bewise.in/bengaluru/after-school-activity/sports/martial-arts-karate`
    },
    {
        image: '/assets/images/ad-banner/300-250-180822-7.png',
        link: `javascript:;`
    },
    {
        image: '/assets/images/ad-banner/300-250-180822-8.png',
        link: `https://www.bewise.in/bengaluru/tuitions/languages/french`
    },
    {
        image: '/assets/images/ad-banner/300-250-180822-9.png',
        link: `javascript:;`
    },
    {
        image: '/assets/images/ad-banner/300-250-180822-10.png',
        link: `https://www.bewise.in/bengaluru/tuitions/languages/french/sangeetha-sethuraman`
    },
]
const banner_arr_rev = banner_arr.slice().reverse();

        var leadad = '';
        var leadlink = '';

        if(window.location.pathname.indexOf("/schools/") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/School.png';
               leadlink = '/best-schools-near-me';
        }

        if(window.location.pathname.indexOf("/pre-schools/") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/Pre School.png';
               leadlink = '/best-preschools-near-me';
        }

        if(window.location.pathname.indexOf("/tuitions/") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/Tuitions.png';
               leadlink = '/best-tuitions-near-me';
        }


        if(window.location.pathname.indexOf("/after-school-activity/sports/") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/Sports.png';
               leadlink = '/best-sports-classes-near-me';
        }


        if(window.location.pathname.indexOf("after-school-activity/music") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/Music Classes.png';
               leadlink = '/best-music-classes-near-me';
        }


        if(window.location.pathname.indexOf("/after-school-activity/dance-and-theatre") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/Dance.png';
               leadlink = '/best-dance-classes-near-me';
        }


        if(window.location.pathname.indexOf("after-school-activity/creative-arts") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/Art.png';
               leadlink = '/best-arts-classes-near-me';
        }


        if(window.location.pathname.indexOf("/after-school-activity/mind-and-skill-enrichment") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/Enrichment.png';
               leadlink = '/best-skill-enrichment-classes-near-me';
        }


        if(window.location.pathname.indexOf("/after-school-activity/hobbies-and-passion") >= 0){
               leadad = 'https://api.bewise.in/uploads/listing/Hobby classes.png';
               leadlink = '/best-hobby-passion-enriching-classes-near-me';
        }

class AdVertical extends React.Component {
    constructor() {
        super();
        this.state = {

        };
    }
    render() {
        const settingsT = {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 8000,
            dots: false,
            arrows: false
        };
        return (
            <React.Fragment>

                <div class="adspace ad380">
                    <Slider {...settingsT}>
                        {banner_arr.map((item, i) => {
                            return (
                               <a href={item.link}><img src={item.image} alt='banner' /></a>
                            )
                        })}
                    </Slider>
                </div>


            </React.Fragment >
        );
    }
}


class AdVerticalLeft extends React.Component {
    constructor() {
        super();
        this.state = {

        };
    }
    render() {
        const settingsT = {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 8000,
            dots: false,
            arrows: false
        };
        return (
            <React.Fragment>

                <div class="adspace ad380">
                    <Slider {...settingsT}>
                        {banner_arr.map((item, i) => {
                            return (
                               <a href={item.link}><img src={item.image} alt='banner' /></a>
                            )
                        })}
                    </Slider>
                </div>


            </React.Fragment >
        );
    }
}


export { AdVertical, AdVerticalLeft };